module.exports = __webpack_public_path__ + "img/no_worries_05.5bc45863.png";